import { render } from "./PcErrorNotFound.vue?vue&type=template&id=4d16595e&scoped=true"
import script from "./PcErrorNotFound.vue?vue&type=script&lang=js"
export * from "./PcErrorNotFound.vue?vue&type=script&lang=js"

import "./PcErrorNotFound.vue?vue&type=style&index=0&id=4d16595e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d16595e"]])

export default __exports__